import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "@/App.css";

import { LanguageProvider, useLang } from "@/i18n/LanguageContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Chatbot } from "@/components/Chatbot";
import { Seo } from "@/components/Seo";
import { LocalBusinessJsonLd } from "@/components/LocalBusinessJsonLd";
import { BreadcrumbJsonLd } from "@/components/BreadcrumbJsonLd";

import Home from "@/pages/Home";
import Genese from "@/pages/Genese";
import Geobiologie from "@/pages/Geobiologie";
import CuisineVivante from "@/pages/CuisineVivante";
import Magnetisme from "@/pages/Magnetisme";
import Therapeutes from "@/pages/Therapeutes";
import Boutique from "@/pages/Boutique";
import Contact from "@/pages/Contact";
import Devis from "@/pages/Devis";
import Bilan from "@/pages/Bilan";
import BilanConfirmation from "@/pages/BilanConfirmation";
import Tarifs from "@/pages/Tarifs";
import PaymentSuccess from "@/pages/PaymentSuccess";
import MentionsLegales from "@/pages/MentionsLegales";
import Frequences from "@/pages/Frequences";
import SentinellesVertes from "@/pages/SentinellesVertes";
import { ScrollToTop } from "@/components/ScrollToTop";

function RouteBreadcrumb() {
  const location = useLocation();
  const { locale } = useLang();
  return <BreadcrumbJsonLd locale={locale} pathname={location.pathname} />;
}

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <LocalBusinessJsonLd />
          <RouteBreadcrumb />
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <div className="flex-1">
              <Routes>
                <Route path="/" element={<><Seo page="home" /><Home /></>} />
                <Route path="/genese" element={<><Seo page="home" /><Genese /></>} />
                <Route path="/geobiologie" element={<><Seo page="geobiologie" /><Geobiologie /></>} />
                <Route path="/cuisine-vivante" element={<><Seo page="cuisine" /><CuisineVivante /></>} />
                <Route path="/magnetisme" element={<><Seo page="magnetisme" /><Magnetisme /></>} />
                <Route path="/therapeutes" element={<><Seo page="therapeutes" /><Therapeutes /></>} />
                <Route path="/boutique" element={<><Seo page="boutique" /><Boutique /></>} />
                <Route path="/contact" element={<><Seo page="contact" /><Contact /></>} />
                <Route path="/devis" element={<><Seo page="devis" /><Devis /></>} />
                <Route path="/bilan" element={<><Seo page="bilan" /><Bilan /></>} />
                <Route path="/bilan-vitalite" element={<><Seo page="bilan" /><Bilan /></>} />
                <Route path="/bilan-confirmation" element={<><Seo page="bilan_conf" /><BilanConfirmation /></>} />
                <Route path="/tarifs" element={<><Seo page="tarifs" /><Tarifs /></>} />
                <Route path="/pricing" element={<><Seo page="tarifs" /><Tarifs /></>} />
                <Route path="/frequences" element={<><Seo page="frequences" /><Frequences /></>} />
                <Route path="/frequencies" element={<><Seo page="frequences" /><Frequences /></>} />
                <Route path="/sentinelles-vertes" element={<><Seo page="sentinelles" /><SentinellesVertes /></>} />
                <Route path="/green-sentinels" element={<><Seo page="sentinelles" /><SentinellesVertes /></>} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/payment-cancel" element={<PaymentSuccess />} />
                <Route path="/mentions-legales" element={<><Seo page="legal" /><MentionsLegales /></>} />
                <Route path="/legal" element={<><Seo page="legal" /><MentionsLegales /></>} />
              </Routes>
            </div>
            <Footer />
            <Chatbot />
          </div>
        </BrowserRouter>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
